import React from 'react';
import { CustomIcon } from 'components/CustomIcon';
import { MBDropdownProps } from 'components/Elements/MBDropdown';
import { MBMenuItem } from 'components/Elements/MBMenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import * as Styled from './Sorting.styles';
import { searchSortingListSelector } from '../../../redux/selectors/searchSortingSelector';
import { currentSortOptionSelector } from '../../../redux/selectors/searchSortingSelector';
import { setCurrentSortOption } from '../../../redux/sliceCreators/sortingSlice';
import { SortOption } from '../../../types';
import { setUrlSortOption } from '../../../utils';

type SortingProps = {
  menuProps?: MBDropdownProps;
  onSort?: (sortItem: SortOption) => void;
};

const Sorting = (props: SortingProps) => {
  const dispatch = useDispatch();
  const sortingList = useSelector(searchSortingListSelector);
  const currentSortOption = useSelector(currentSortOptionSelector);
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });

  const handleSortOptionClick = (sortItem: SortOption) => {
    if (sortItem.label === currentSortOption?.label) {
      dispatch(setCurrentSortOption(null));
      setUrlSortOption(undefined, true);
    } else {
      dispatch(setCurrentSortOption(sortItem));
      setUrlSortOption(sortItem);
    }
    props.onSort?.(sortItem);
  };

  if (isMobile) {
    return sortingList?.map((sortItem: SortOption, index: number) => (
      <Styled.Option
        key={index}
        onClick={() => handleSortOptionClick(sortItem)}
      >
        <Styled.OptionName>{sortItem.label}</Styled.OptionName>
        <Styled.SelectedIcon
          variant="body"
          show={currentSortOption?.label === sortItem.label}
        >
          <CustomIcon name="tick" dense />
        </Styled.SelectedIcon>
      </Styled.Option>
    ));
  }

  return (
    <Styled.Dropdown
      {...props.menuProps}
      onClose={props.menuProps?.onClose || (() => {})}
      open={props.menuProps?.open || false}
    >
      {sortingList?.map((sortItem: SortOption, index: number) => {
        // with just label validation - we can't set sort option,
        // when it comes from paramOverride  in Search API
        const isSelected =
          sortItem.field === currentSortOption?.field &&
          sortItem.direction === currentSortOption?.direction;
        return (
          <MBMenuItem
            key={index}
            isSelected={isSelected}
            onClick={() => handleSortOptionClick(sortItem)}
          >
            {sortItem.label}
          </MBMenuItem>
        );
      })}
    </Styled.Dropdown>
  );
};

export { Sorting };
